import { BillItem, BillItemCategory } from '../types/bills'

export const BILL_ITEM_CATEGORY_ORDER: BillItemCategory[] = [
    'rent',
    'premium',
    'fee',
    'late_fee',
    'damage',
    'concession',
    'other',
]

export const BILL_ITEM_CATEGORY_LABELS: Record<BillItemCategory, string> = {
    rent: 'Rent',
    premium: 'Premiums',
    fee: 'Fees',
    late_fee: 'Late fees',
    damage: 'Damages',
    concession: 'Credits',
    other: 'Other',
}

export const BILL_ITEM_CATEGORY_COLORS: Record<BillItemCategory, string> = {
    rent: '#2dd4bf',
    premium: '#c084fc',
    fee: '#60a5fa',
    late_fee: '#fbbf24',
    damage: '#fb923c',
    concession: '#4ade80',
    other: '#94a3b8',
}

export const getBillItemCategory = (item: BillItem): BillItemCategory => {
    if (item.category) {
        return item.category
    }
    const code = (item.charge_code || '').trim().toUpperCase()
    const amount = Number(item.amount)
    if (code === 'RENT') {
        return 'rent'
    }
    if (code.startsWith('PREMIUM:')) {
        return 'premium'
    }
    if (code === 'DAMAGE') {
        return 'damage'
    }
    if (code === 'CONCESSION' || amount < 0) {
        return 'concession'
    }
    if (code === 'LATE' || code === 'LATE_FEE' || code === 'LATEFEE') {
        return 'late_fee'
    }
    if (!code) {
        return 'other'
    }
    return 'fee'
}

export const isCreditBillItem = (item: BillItem) => {
    return getBillItemCategory(item) === 'concession' || Number(item.amount) < 0
}

export const groupBillItemsByCategory = (items: BillItem[]) => {
    const groups = BILL_ITEM_CATEGORY_ORDER.map((category) => ({
        category,
        label: BILL_ITEM_CATEGORY_LABELS[category],
        color: BILL_ITEM_CATEGORY_COLORS[category],
        items: [] as BillItem[],
        total: 0,
    }))
    const byCategory = new Map(groups.map((group) => [group.category, group]))

    items.forEach((item) => {
        const category = getBillItemCategory(item)
        const group = byCategory.get(category)
        if (!group) {
            return
        }
        group.items.push(item)
        group.total += Number(item.amount) || 0
    })

    return groups.filter((group) => group.items.length > 0)
}
